import { render, staticRenderFns } from "./ManterProcuradorEditar.vue?vue&type=template&id=82e5dab2&scoped=true&"
import script from "./ManterProcuradorEditar.vue?vue&type=script&lang=js&"
export * from "./ManterProcuradorEditar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82e5dab2",
  null
  
)

export default component.exports